import { render, staticRenderFns } from "./InputNew.htm?vue&type=template&id=20864e9a&scoped=true&"
import script from "./InputNew.js?vue&type=script&lang=js&"
export * from "./InputNew.js?vue&type=script&lang=js&"
import style0 from "./InputNew.scss?vue&type=style&index=0&id=20864e9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20864e9a",
  null
  
)

export default component.exports